exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preloader-bg[data-v-55710dbb]{background-color:hsla(0,0%,100%,.8);height:100%;left:0;top:0;width:100%;z-index:100}", ""]);

// exports
